// extracted by mini-css-extract-plugin
export default {"mainWrapper":"AuthLayout_mainWrapper__1L4Xk"};